import { useMemo } from "react";
import { createTidalTheme } from "./createTidalTheme.js";
function useCreateTidalTheme(colorMode, theme) {
  return useMemo(() => createTidalTheme(theme, colorMode), [theme, colorMode]);
}
export {
  useCreateTidalTheme
};
//# sourceMappingURL=useCreateTidalTheme.js.map
